import dayjs from "dayjs"
import { useTranslation } from "react-i18next"

import { HomeNS } from "../i18n/constants"

export const useSurgeryMessage = (surgeryDate?: Date) => {
  const { t } = useTranslation(HomeNS)

  const getDaysDifference = () => {
    if (!surgeryDate) {
      return null
    }
    return dayjs().startOf("day").diff(dayjs(surgeryDate).startOf("day"), "day")
  }

  const getSurgeryMessage = () => {
    const daysDiff = getDaysDifference()
    if (daysDiff === null) {
      return null
    }

    if (daysDiff < -1) {
      return t("preOperativeProgram")
    } else if (daysDiff === -1) {
      return t("dayBeforeSurgery")
    } else if (daysDiff === 0) {
      return t("surgeryDay")
    } else {
      return t("postOperativeDay", { days: daysDiff })
    }
  }

  return {
    daysDifference: getDaysDifference(),
    surgeryMessage: getSurgeryMessage(),
  }
}
